import { formatInTimeZone } from 'date-fns-tz';
import { it } from 'date-fns/locale';

//const locales = { enGB, it, es, 'it-IT': it };
//const defaultTimezone = 'it';

const useDateFormat = () => {
  const formatDate = (date: string | number | Date, formatStr = 'PP') => {
    return formatInTimeZone(date, 'Europe/Rome', formatStr, {
      locale: it, // or global.__localeId__
    });
    /*    return formatInTimeZone(date, 'it', formatStr, {
      locale: it, // or global.__localeId__
    });*/
  };

  return {
    formatDate,
  };
};

export default useDateFormat;
